import { Injectable } from "@angular/core";
import { HttpService } from "src/app/services/http.service";
import { OFFERS_GET, VALIDATE_COUPON } from "src/app/constant/urls";
import { UtilityService } from "src/app/services/utility.service";

@Injectable({
  providedIn: "root",
})
export class ApplyCouponService {
  constructor(private http: HttpService, private utility: UtilityService) {}

  getOffers(): Promise<any> {
    return this.http
      .get(OFFERS_GET(this.utility.getRestaurantId()))
      .toPromise();
  }

  validateCoupon(query: any): Promise<any> {
    console.log(query);
    if (query.couponType == "Mix&Match") {
      query.couponType = query.couponType.split("&").join("%26");
    }
    return this.http.get(VALIDATE_COUPON(query)).toPromise();
  }
}
